<template>
  <date-range-picker
            ref="picker"
            v-model="dateRange"
            :opens="opens"
            :locale-data="locale"
            :minDate="minDate" :maxDate="maxDate"
            :singleDatePicker="false"
            :timePicker="false"
            :timePicker24Hour="true"
            :showWeekNumbers="false"
            :showDropdowns="true"
            :autoApply="false"
            :ranges="ranges"
            @update="onDateSelected"
            :linkedCalendars="true">
        <div slot="input" slot-scope="picker" style="min-width: 150px;">
            {{ $moment(picker.startDate).format('YYYY-MM-DD') }} - {{  $moment(picker.endDate).format('YYYY-MM-DD')  }}
        </div>
    </date-range-picker>
</template>

<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'RangeDatePicker',
  components: {
    DateRangePicker
  },
  props: {
    initRange: {
      type: Object,
    }
  },
  data() {
    return {
      dateRange: {
        startDate: this.initRange ? this.initRange.start : this.$store.getters.lastDateRange.start,
        endDate: this.initRange ? this.initRange.end : this.$store.getters.lastDateRange.end
      },
      minDate: '2019-01-01',
      maxDate: moment().toDate(),
      opens: 'left',
      locale: {
        direction: 'ltr', // direction of text
        format: 'YYYY-MM-DD', // fomart of the dates displayed
        separator: ' ~ ', // separator between the two ranges
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(), // array of days - see moment documenations for details
        monthNames: moment.monthsShort(), // array of month names - see moment documenations for details
        firstDay: 0 // ISO first day of week - see moment documenations for details
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'This month': [moment().startOf('month'), moment().endOf('month')],
        'This year': [moment().startOf('year'), moment().endOf('year')],
        'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      }
    }
  },
  methods: {
    onDateSelected(selected) {
      const searchOption = {
        start: moment(selected.startDate).format('YYYY-MM-DD'),
        end: moment(selected.endDate).format('YYYY-MM-DD')
      }
      this.$store.commit('setLastDateRange', searchOption)
      this.$emit('selected', searchOption)
    },
  }
}
</script>
<style scoped>
  .date-picker {
    display: inline-block;
  }
</style>
